import { AxiosInstance } from "axios";
import { toast } from "react-toastify";
import dayjs from "dayjs";

export interface CampaignQueryResponse {
  err: string;
  cu_id: string;
  campaign: CampaignType[];
  schoolCampaignCode?: schoolCampaignCodeType[];
}

export interface schoolCampaignCodeType {
  profname: string;
  invcode: string;
}

export interface CampaignType {
  code: string;
  name: string;
  t_open: string;
  t_close: string;
  s_timeToe_time?: string;
  d_start: string;
  d_end: string;
  d_start_end?: string;
  init_cash: number;
  realtime: string;
  status: boolean;
  m_type: string;
  action?: string;
  phone?: string;
  email?: string;
  school_campaign?: boolean;
  joinSC?: boolean;
  mailverifyflag?: boolean;
  mailverify? : "0" | "1" | "2"; //0:未驗證 1:驗證中 2:驗證成功  後端回傳是字串
  //0903判斷是否為學生驗證
}

function Formatter(data: CampaignType): CampaignType {
  return {
    code: data.code,
    name: data.name,
    t_open: data.t_open,
    school_campaign: data.school_campaign,
    t_close: data.t_close,
    s_timeToe_time:
      data.t_open && data.t_close
        ? data.t_open.substring(0, 2) + ":" + data.t_open.substring(2, 4) + "~" + data.t_close.substring(0, 2) + ":" + data.t_close.substring(2, 4)
        : "--",
    d_start: data.d_start,
    d_end: data.d_end,
    d_start_end:
      dayjs(data.d_start).format("YYYY.MM.DD") + "~" + dayjs(data.d_end).format("YYYY.MM.DD"),
    init_cash: data.init_cash,
    realtime: data.realtime ? "即時" : "回播",
    status: data.status || false,
    m_type: data.m_type,
    joinSC: data.joinSC,
    mailverifyflag: data.mailverifyflag,
    mailverify: data.mailverify,
  };
}

export const getCampaignQuery = async (axios: AxiosInstance) => {
  const accInfo = (window.parent as any).reactGetLoginInfo();
  console.log("accInfo", accInfo)

  if (accInfo.phone === "" || accInfo.email === "") {
    (window.parent as any).openLoginModal();
    return;
  }

  const requestData = JSON.stringify({
    phone: accInfo.phone,
    email: accInfo.mail,
  });

  const headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  const baseURL = `${process.env.REACT_APP_URL}api2/Warrant`;

  try {
    const response = await axios.post<CampaignQueryResponse>(
      `/CampaignQuery`,
      requestData,
      {
        baseURL, 
        headers,
        withCredentials: true,
      }
    );

    if (!response.data) {
      return { err: "9999", cu_id: "", campaign: [] };
    }

    if (response.data.err !== "0000") {
      toast.warn(`活動清單${":(" + response.data.err + ")"}`, {
        position: "top-right",
        autoClose: 1300,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }

    const nowState = (window.parent as any).location.href.includes("tradSchoolCampaign");
    let campaignArray = response.data.campaign
      .filter(item => (nowState ? item.school_campaign : !item.school_campaign))
      .map(Formatter);

    return {
      error: response.data.err,
      cu_id: response.data.cu_id,
      schoolCampaignCode: response.data.schoolCampaignCode,
      campaign: campaignArray,
    };
  } catch (error) {
    console.error(error);
    return { err: "9999", cu_id: "", campaign: [] };
  }
};
